module.exports = __webpack_public_path__ + "img/symbol_10.168bc324.png";